import { addCustomerEntry, addGlobalData, setGlobalDataCreatedClaim, setStepEngineCreatedBenefit, setStepEngineCreatedClaim } from 'app/modules/step-engine/service/store/step-engine-dispatchs';
import { CustomerEntryName, Step } from 'app/modules/step-engine/utils/step-engine-constants';
import { NO, OTHER_OPTION, YES } from 'app/shared/constants/constants';
import { claimApi } from '../api/claim-api';
import { setClaim } from './store/claim-dispatch';
import { benefitApi } from 'app/modules/benefit/api/benefit-api';
import { getBenefit } from 'app/modules/benefit/benefit-service/benefit-service';

export const generateParams = (data, cmsContent, previousSteps) => {
  const globalData = { ...data };
  globalData.comment = '';
  Object.keys(previousSteps).forEach(steps => {
    steps.split(',').forEach(keyData => {
      const keyDataCamelCase = Step[keyData];
      const gtmLabel = cmsContent[keyDataCamelCase]?.prismic?.gtmLabel;
      const title = cmsContent[keyDataCamelCase]?.prismic?.title;
      const question = gtmLabel ? gtmLabel : title;
      const ignoreComment = cmsContent[keyDataCamelCase]?.behaviors?.ignoreComment ?? false;
      const ignore = ignoreComment === true || (ignoreComment instanceof Array && ignoreComment.includes(keyData));
      if (!ignore) {
        if (typeof globalData[keyDataCamelCase] === 'string') {
          // TODO : FIX string de type Date (code: "0", label: "Hier", value: "2021-11-03T12:26:18") on doit prendre value au lieu de label
          globalData.comment = globalData.comment.concat('§'+question, ' ', globalData[keyDataCamelCase], '\n');
        } else if (globalData[keyDataCamelCase] instanceof Array) {
          let comment = '';
          comment = globalData[keyDataCamelCase]
            .map(item => {
              if (item.description) {
                return item.description;
              } else if (item.label) {
                if (item.values) {
                  return item.label + ' ' + item.values.join(' - ');
                } else {
                  return item.label;
                }
              } else {
                return item.value;
              }
            })
            .join(', ');
          globalData.comment = globalData.comment.concat('§'+question, ' ', comment, '\n');
        } else if (globalData[keyDataCamelCase] instanceof Object) {
          globalData.comment = globalData.comment.concat(
            '§'+question,
            ' ',
            globalData[keyDataCamelCase].option ?
              globalData[keyDataCamelCase].option?.value === OTHER_OPTION ?
                globalData[keyDataCamelCase].otherOption
                :
                globalData[keyDataCamelCase].option?.label
              :
              globalData[keyDataCamelCase].description ?
                globalData[keyDataCamelCase].description
                : globalData[keyDataCamelCase].label
                  ? globalData[keyDataCamelCase].label
                  : globalData[keyDataCamelCase].name
                    ? globalData[keyDataCamelCase].name
                    : globalData[keyDataCamelCase].value,
            '\n'
          );
        }
      }
    });
  });
  globalData.damagedGoodDate = data?.damagedGoodDate?.value;
  globalData.claimDeclarationDate = data?.claimDeclarationDate?.value
  return globalData;
};

export const claimTransmit = (globalData, cmsContent, previousSteps) => async dispatch => {
  let params = generateParams(globalData, cmsContent, previousSteps);
  try {
    if(!sessionStorage.getItem('claimTransmit')){
    const responseClaimTransmit = await claimApi.claimTransmit(params);
    if (responseClaimTransmit?.status === 200 || responseClaimTransmit?.status === 201) { 
      sessionStorage.setItem('claimTransmit', "1") ;
      const claimNumber = responseClaimTransmit?.data;
      params = { ...params, createdClaimNumber: claimNumber };
      const response = await claimApi.benefitManagement(params, claimNumber);
      if (response?.status === 200 || response?.status === 201) {
        await dispatch(setClaim(response?.data));
        await dispatch(setStepEngineCreatedClaim(claimNumber));
        await dispatch(setStepEngineCreatedBenefit(response?.data?.benefitId));
        const benefitId = response?.data?.benefitId;
        if (benefitId) {
          await dispatch(getBenefit(benefitId));
        } else {
          console.log("Aucun benefitId trouvé !");
        }
        return response;
      } else {
        throw new Error('Creating Claim benefit management Error');
      }
    }
  }
  } catch (error) {
    throw new Error('Creating Claim Error');
  }
};

export const getClaim = claimNumber => async dispatch => {
  await claimApi
    .getClaim(claimNumber)
    .then(response => {
      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: 'claim/SET_CLAIM',
          payload: { trackingNumber: null, ...response.data },
        });
        return response;
      } else {
        return Promise.reject('Retrieving Claim Error');
      }
    })
    .catch(error => {
      return Promise.reject('Retrieving Claim Error');
    });
};

export const detectRefusal = (globalData, cmsContent, previousSteps) => async dispatch => {
  const params = generateParams(globalData, cmsContent, previousSteps);

  const response = await claimApi.detectRefusal(params);

  if (response.status === 200 || response.status === 201) {
    if (response.data === true) {
      await dispatch(addCustomerEntry(CustomerEntryName.REFUSAL_DETECTED, YES));
    } else {
      await dispatch(addCustomerEntry(CustomerEntryName.REFUSAL_DETECTED, NO));
    }
  } else {
    throw new Error('detect refusal Error'); //
  }
};

export const updateClaimDetails = data => async (dispatch, getState) => {
  const { claimNumber } = getState().claim;
  const claimDetailsDto: any = {
    claimNumber,
    details: data,
  };
  const response = await claimApi.updateClaimDetails(claimDetailsDto);
  if (response.status === 200 || response.status === 201) {
    return response;
  } else {
    throw new Error('update claim details Error');
  }
};

export const modifyClaim = (payload: any) => dispatch => {
  dispatch({
    type: 'claim/SET_CLAIM',
    payload,
  });
};

export const getClaimProductCode = (idSubscription: any) => async (dispatch,getState) => {
  const { subscriptionNumber } = getState().kubrickManagement.subscription;
  const response = await claimApi.getClaimProductCode(idSubscription ?? subscriptionNumber);
  if (response.status === 200 || response.status === 201) {
    dispatch(addGlobalData('claimProductCode', response.data));
    return response;
  } else {
    throw new Error('get claim product code Error');
  }
};

export const terminateClaim = (previousSteps, cmsContent, globalData, claimNumber, benefitId) => async dispatch => {
    const params = generateParams(globalData, cmsContent, previousSteps);

    try {
        const response = await claimApi.terminateClaim(params, claimNumber, benefitId)
        if ((response.status === 200 || response.status === 201) && response.data) {
            return response;
        } else {
            return false;
        }
    }
    catch (error) {
        throw new Error('Terminate Claim Error : ' + error);
    }
};

export const saveClaimErrorLog = (data: any) => dispatch => {
  claimApi.saveClaimErrorLog(data)
};

